export function isGachaWalletCancellationMessage(message: string) {
  const normalized = message.toLowerCase()

  return (
    normalized.includes("user rejected") ||
    normalized.includes("user denied") ||
    normalized.includes("rejected the request") ||
    normalized.includes("cancelled") ||
    normalized.includes("canceled")
  )
}
